// extracted by mini-css-extract-plugin
export var root = "H_vN";
export var wrapper = "H_vP";
export var image = "H_vQ d_w d_y d_W";
export var imageWithHeight = "H_vR";
export var crop = "H_vS";
export var round = "H_vT";
export var fixedHeight = "H_vV";